var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWindTurbine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M302.1 431.2c18.2 29.6 64 13 58.9-21.4L332.7 217.6 425 46.8c16.5-30.6-20.8-61.9-48-40.3L224.8 127.1 30.7 132.6c-34.8 1-43.2 48.9-10.9 61.7l180.6 71.5L240 330.3V480H144c-8.8 0-16 7.2-16 16s7.2 16 16 16H256 368c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V382.3l30.1 49zM301 222.3l28.4 192.1L227.6 249c-3.6-5.9-9-10.4-15.5-13L31.6 164.5l194.1-5.4c6.9-.2 13.6-2.6 19-6.9L396.9 31.6 304.5 202.4c-3.3 6.1-4.5 13.1-3.5 19.9zM272 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindTurbine);
export default __webpack_public_path__ + "static/media/wind-turbine.d222c8dc81fc051d7c8f6f6c624ceb54.svg";
export { ForwardRef as ReactComponent };